var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.058 0.369013L10.1582 0.435967L10.2443 0.510967C10.5623 0.836384 10.5838 1.34414 10.3117 1.6961L10.2303 1.78797L4.42725 7.48997C4.10458 7.80805 3.60798 7.83456 3.25555 7.56949L3.16325 7.48997L0.26925 4.62097C-0.08975 4.26897 -0.08975 3.69497 0.26925 3.34297C0.591917 3.0258 1.08852 2.99937 1.44095 3.26368L1.53325 3.34297L3.80825 5.58797L8.97825 0.509967C9.27189 0.221785 9.71346 0.170794 10.058 0.369013Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheck);
export default __webpack_public_path__ + "static/media/ico-check.d727d874612201f85baac678b5f436f7.svg";
export { ForwardRef as ReactComponent };